var _mask, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgReactangleExtension1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 227,
    viewBox: "0 0 232 227",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1061_1395",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.679 226.993H-0.000565282L-0.000854492 101.5L232 0L125.679 226.993Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125.679 226.993H-0.000565282L-0.000854492 101.5L232 0L125.679 226.993Z",
    fill: "#FD732E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126.179 226.997L127.301 101.504L126.301 101.496L125.179 226.988L126.179 226.997ZM126.801 101H-0.000854492V102H126.801V101ZM127.148 101.86L232.347 0.359822L231.652 -0.359822L126.454 101.14L127.148 101.86ZM-0.000565282 226.993L-1.00057 226.993L-1.00056 227.993H-0.000565282V226.993ZM125.679 226.993V227.993H126.315L126.584 227.417L125.679 226.993ZM-0.000854492 101.5L-0.401673 100.584L-1.00086 100.846L-1.00085 101.5L-0.000854492 101.5ZM232 0L232.905 0.424166L234.032 -1.98046L231.599 -0.916158L232 0ZM-0.000565282 227.993H125.679V225.993H-0.000565282V227.993ZM0.399964 102.416L232.4 0.916158L231.599 -0.916158L-0.401673 100.584L0.399964 102.416ZM126.584 227.417L232.905 0.424166L231.094 -0.424166L124.773 226.569L126.584 227.417ZM-1.00085 101.5L-1.00057 226.993L0.999435 226.993L0.999146 101.5L-1.00085 101.5Z",
    fill: "#101010",
    mask: "url(#path-1-inside-1_1061_1395)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0009 183.5H29.0009V197.5H43.0009V183.5Z",
    fill: "#EFE4D2",
    stroke: "#EFE4D2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9991 134.5H35.9991V155.5H91.9991V134.5Z",
    fill: "#EFE4D2",
    stroke: "#EFE4D2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64 183.5V155.5",
    stroke: "#EFE4D2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9991 183.5V169.5H91.9991V183.5",
    stroke: "#EFE4D2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M99 183.5H85V197.5H99V183.5Z",
    fill: "#EFE4D2",
    stroke: "#EFE4D2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9991 183.5H56.9991V197.5H70.9991V183.5Z",
    fill: "#EFE4D2",
    stroke: "#EFE4D2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4991 145H49.9991",
    stroke: "#FD732E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgReactangleExtension1);
export default __webpack_public_path__ + "static/media/bgReactangleExtension1.e72afa58f77edf27da9442ede83c0070.svg";
export { ForwardRef as ReactComponent };